// ─────────────────────────────────────────────────────────────────────────────
// Central place for the native-app deep link + app-store fallbacks so the header,
// footer and landing pages all stay in sync. Replace the placeholder store IDs /
// custom scheme with the production values before going live.
// ─────────────────────────────────────────────────────────────────────────────

export const APP_SCHEME = 'mainevent://'; // custom URL scheme that opens the app
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.seuytel.mainevents';
export const APP_STORE_URL = 'https://apps.apple.com/app/main-events/id6789583163';

// Where "the website" version of the app lives (used on desktop, where there is
// no native app to fall back to). This is the in-app web experience root.
export const WEBSITE_PATH = '/events';

const UA = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';

export const IS_IOS = /iPhone|iPad|iPod/i.test(UA);
export const IS_ANDROID = /Android/i.test(UA);
export const IS_MOBILE = IS_IOS || IS_ANDROID;

/** The right store for the current device (defaults to Play for non-iOS). */
export function storeUrl(): string {
    return IS_IOS ? APP_STORE_URL : PLAY_STORE_URL;
}

/**
 * Try to open the installed native app via its custom scheme; if nothing handles
 * it within a short window (i.e. the app isn't installed) fall back to the store
 * so the user can download it.
 */
export function openAppOrStore(): void {
    const start = Date.now();
    const fallback = window.setTimeout(() => {
        // If the app opened, the page is backgrounded and this timer is throttled,
        // so a large elapsed gap means we never left — send them to the store.
        if (Date.now() - start < 2200) {
            window.location.href = storeUrl();
        }
    }, 1400);

    // Cancel the store fallback if the page is hidden (the app took over).
    const onHide = () => {
        if (document.visibilityState === 'hidden') window.clearTimeout(fallback);
    };
    document.addEventListener('visibilitychange', onHide, { once: true });

    try {
        window.location.href = APP_SCHEME;
    } catch {
        window.location.href = storeUrl();
    }
}
